import React from 'react';
import { IconButton, Typography, Box } from '@mui/material';
import { ChatBubbleOutlineOutlined } from '@mui/icons-material';
import theme from '../../theme';

const CommentReplyButton = ({ count, onClick }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton
        disableRipple
        onClick={onClick}
        aria-label="reply to comment"
        sx={{
          width: 20,
          height: 20,
          padding: 0,
        }}
      >
        <ChatBubbleOutlineOutlined sx={{ fontSize: '20px', color: '#777777 !important' }} />
      </IconButton>
      {count > 0 && (
        <Typography fontSize={14} color={theme.palette.black[4]}>
          {count}
        </Typography>
      )}
    </Box>
  );
};

export default CommentReplyButton;
